var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#282B2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9962 18.4717L44.1317 23.8704C44.9191 24.2522 45.4195 25.0503 45.4202 25.9255L45.4286 38.1017C45.4286 38.9794 44.9262 39.7794 44.1356 40.1607L32.9931 45.5335C32.3658 45.8359 31.6348 45.8359 31.0075 45.5335L19.8649 40.1607C19.0744 39.7794 18.572 38.9794 18.572 38.1017L18.5715 25.923C18.5715 25.0467 19.0725 24.2475 19.8612 23.8656L31.003 18.4711C31.6325 18.1663 32.3669 18.1665 32.9962 18.4717Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24.5993L31.9998 30.8625L18.9961 24.5923",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 30.8628V45.4289",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile4);
export default __webpack_public_path__ + "static/media/profile_4.182a3dce60ef2476d1e3334c7f09311f.svg";
export { ForwardRef as ReactComponent };